import { useState, useCallback } from "react";

// Custom hooks: Outsource stateful logic into re-usable functions.
// Unlike "regular functions", custom hooks can use other React
// hooks end React state.
// Name MUST start with use....
const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // requestConfig is een object met daarin o.a. de URL.
  // This custom hook assumes we are working with JSON data.
  // applyData is een functie die afkomstig is van de aanroepende component.
  // In deze custom hook krijgt deze functie de data van deze hook.
  // De logica wat er moet gebeuren met de data zit dus in de aanroepende component.
  const sendRequest = useCallback(async (requestConfig, fncResponseData) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(requestConfig.url, {
        method: requestConfig.method ? requestConfig.method : "GET",
        headers: requestConfig.headers ? requestConfig.headers : {},
        body: requestConfig.body ? JSON.stringify(requestConfig.body) : null,
      });

      console.log(response);

      if (!response.ok) {
        throw new Error("Request failed!");
      }

      const data = await response.json();
      console.log(data);
      fncResponseData(data);
    } catch (err) {
      setError(err.message || "Something went wrong!");
    }
    setIsLoading(false);
  }, []);

  // return van useHttp
  return {
    isLoading,
    error,
    sendRequest,
    // Omdat links en rechts dezelfde naam, mag je bovenstaande verkorte versie gebruiken
    //isLoading: isLoading,
    //error: error,
    //sendRequest: sendRequest,
  };
};

export default useHttp;